export const ENDPOINT_CONFIGS = '/cart-api/get-configs';
export const ENDPOINT_SEARCH = '/cart-api/search-dates';
export const ENDPOINT_BOOKING_SETUP = '/cart-api/setup-booking';
export const ENDPOINT_PROMO_CODE = '/cart-api/setup-promo';
export const ENDPOINT_PAYMENT_INIT = '/cart-api/init-payment';
export const ENDPOINT_PROCESS_PAYMENT = '/cart-api/process-payment';
export const ENDPOINT_SAVE_DRAFT = '/cart-api/save-draft';

export const ENDPOINT_CHARTER_CONFIGS = '/cart-api/get-charter-configs';
export const ENDPOINT_CHARTER_SEARCH = '/cart-api/charter-search';
export const ENDPOINT_CHARTER_BOOK = '/cart-api/charter-book';
